import { DialogBody } from "@blueprintjs/core";
import { useWrapup } from "../wrapupcontext";
import { WrapupModuleTeamsData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import getItemById from "@/src/util/getItemById";
import pluralize from "@/src/util/pluralize";
import styles from './wrapup.module.css';
import WrapupModuleAvatar, { WrapupUserAvatarSize } from "./avatar";

export default function WrapupModuleTeamsComponent(): React.ReactNode {
    const { wrapupData } = useWrapup();

    const data = wrapupData.data.teams as WrapupModuleTeamsData;
    const topTeammate = data.teammates[0];
    const topTeammateUserId = topTeammate[0];
    const topTeammatePlayCount = topTeammate[1];
    const topTeammateWinCount = topTeammate[2];
    const topTeammateUser = getItemById(wrapupData.users, topTeammateUserId);

    return <DialogBody className={styles.dialogBody}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
            <h1>Teams</h1>
            <h3>Our armies are stronger together. In all of your {pluralize(data.teamGames, 'team game')}, you partnered with one general the most...</h3>
            <WrapupModuleAvatar user={topTeammateUser} />
            <h3>You played with {topTeammateUser.name} {pluralize(topTeammatePlayCount, 'time')} and won {Math.round(100 * topTeammateWinCount / topTeammatePlayCount)}% of the time</h3>
            <h3>Your top teammates:</h3>
            <table>
                <thead>
                    <tr style={{ fontWeight: 'bold' }}>
                        <td></td>
                        <td>Name</td>
                        <td>Plays</td>
                        <td>Wins</td>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.teammates.map(
                            (entry) => {
                                const userId = entry[0];
                                const count = entry[1];
                                const winCount = entry[2];
                                const user = getItemById(wrapupData.users, userId);

                                return <tr key={userId}>
                                    <td>
                                        <WrapupModuleAvatar user={user} size={WrapupUserAvatarSize.Small} />
                                    </td>
                                    <td>{user.name}</td>
                                    <td>{count}</td>
                                    <td>{winCount}</td>
                                </tr>
                            }
                        )
                    }
                </tbody>
            </table>
        </div>
    </DialogBody>
}
